import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as types from './types';
import fetchCategory from '~/services/category';
const MOCK_ORIGIN_URL = 'https://mock';
export default {
  fetchContent(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      let {
        alias,
        query,
        profileId
      } = _ref2;
      const {
        category
      } = yield fetchCategory(_this, alias, query, profileId);

      if (!category) {
        commit(types.SET_PRODUCTS, {
          products: [],
          total: 0
        });
        return;
      }

      const {
        details,
        total,
        products,
        earlybirdsWidgets
      } = category;
      const {
        currentLocale
      } = _this.state.i18n;
      const currentQuery = keys(query).length ? "?".concat(stringify(query)) : '';
      const currentAlias = "".concat(details.slug, "-").concat(details.hash);

      if (alias !== currentAlias && process.server && details.slug !== null) {
        _this.app.context.redirect(301, "/".concat(currentLocale.market, "/").concat(currentLocale.language, "/c/").concat(currentAlias).concat(currentQuery));
      }

      const isRedirect = details.routing && details.routing.isRedirect;

      if (isRedirect) {
        const redirectData = details.routing;

        if (process.server && redirectData.newUrl) {
          _this.app.context.redirect(redirectData.httpCode, "".concat(redirectData.newUrl).concat(currentQuery));
        } else {
          const url = new URL(redirectData.newUrl, MOCK_ORIGIN_URL);
          const redirectUrl = url.href.replace('mock/', '');

          if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
            _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
          } else {
            window.location.href = "".concat(redirectUrl).concat(currentQuery);
          }
        }

        return;
      }

      commit(types.SET_DESCRIPTION, _objectSpread({}, details, {
        earlybirdsWidgets
      }));
      commit(types.SET_PRODUCTS, {
        products,
        total
      });
    })();
  },

  appendProducts(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;
      let {
        alias,
        query,
        profileId
      } = _ref4;
      const {
        category: {
          products
        }
      } = yield fetchCategory(_this2, alias, query, profileId);
      commit(types.APPEND_PRODUCTS, products);
    })();
  },

  prependProducts(_ref5, _ref6) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref5;
      let {
        alias,
        query,
        profileId
      } = _ref6;
      const {
        category: {
          products
        }
      } = yield fetchCategory(_this3, alias, query, profileId);
      commit(types.PREPEND_PRODUCTS, products);
    })();
  }

};